/** @jsx jsx */
import React from "react";
import { HandIcon, Periodos, Periodos2, Corners } from "@/data"
import PDFRegulamento2024 from '../documents/2025/Edital-VITALIS-2025.pdf'
import PDFSyllabus2023 from '../documents/2023/Syllabus2023.pdf'
import { jsx } from "@emotion/react";
import { Link } from "gatsby";

import { 
    cronogramaSection, 
    linksGabaritos,
} from "../assets/styles/Cronograma.style";

import {
  sessionBt,
} from "../assets/styles/QuemPode.styles";

import {
  secTitle,
  commonSection,
  commonBtn,
} from "../assets/styles/layout.styles";

const { secondaryCBL } = Corners;

const Cronograma = () => {
    const { iconHand } = HandIcon;
    
  return (
    <section id="cronograma" css={[commonSection,cronogramaSection]}>
        
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-sm-12 col-md-12 text-center">
            <h2 css={secTitle}>Cronograma e Regulamento</h2>
          </div>
          {/* <div css={periodoInfo} style={{ padding: 0, textAlign: 'center', width: '100%', marginTop: 24 }}>
            <h3 style={{ marginBottom: 32 }}>Segunda Fase</h3>
          </div> */}

          {/* {Periodos.map(({ dataInicial, mesInicial,dataFinal, mesFinal,title, subTitle }, index) => (
            <div css={dataItem}>
                <div css={periodo}>
                    <div>{dataInicial}<span>{mesInicial}</span></div>
                    {index > 0 ? '' : <div>a</div>}
                    {index > 0 ? '' : <div>{dataFinal}<span>{mesFinal}</span></div>}
                </div>
                <div css={periodoInfo}>
                    <h3>{title}</h3>
                    <p>{subTitle}</p>
                </div>
            </div>
          ))} */}

        {/* <div css={periodoInfo} style={{ padding: 0, textAlign: 'center', width: '100%', marginTop: 40 }}>
            <h3 style={{ marginBottom: 32 }}>Terceira Fase</h3>
          </div>

          {Periodos2.map(({ dataInicial, mesInicial,dataFinal, mesFinal,title, subTitle }, index) => (
            <div css={dataItem}>
                <div css={periodo}>
                    <div>{dataInicial}<span>{mesInicial}</span></div>
                    {index > 0 ? '' : <div>a</div>}
                    {index > 0 ? '' : <div>{dataFinal}<span>{mesFinal}</span></div>}
                </div>
                <div css={periodoInfo}>
                    <h3>{title}</h3>
                    <p>{subTitle}</p>
                </div>
            </div>
          ))} */}
        <div className="col-lg-q col-sm-12 col-md-2 text-center"/>
        <div css={linksGabaritos} className="col-lg-8 col-sm-12 col-md-8 text-center">
          <a css={[commonBtn, sessionBt]} href={PDFRegulamento2024} style={{ marginTop: 0 }}><img src={iconHand} alt="Rgulamento"/> Baixe o Cronograma e Regulamento 2025</a>
        </div>
        <div className="col-lg-q col-sm-12 col-md-2 text-center"/>
        {/* <div css={emBreve}>
          <h2>Em breve</h2>
          <p>Fique atento(a)!</p>
        </div> */}

        </div>
      </div>

      <img src={secondaryCBL} className="cbl" />
    </section>
  );
};

export default Cronograma;
